module.exports = __webpack_public_path__ + "static/img/more.e3f44e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/more.jpg
// module id = X0mA
// module chunks = 0